module.exports = __webpack_public_path__ + "static/media/cliente-scp.fe676cfb.svg";